import { useTranslation } from "react-i18next";

const MAINTENANCE_BANNER_KEY = "banners.maintenance";

export const MaintenanceBanner = () => {
  const { t } = useTranslation();

  const text = t(MAINTENANCE_BANNER_KEY, { defaultValue: "" });

  if (!text) return null;

  return (
    <div
      className="px-6 pt-4 pb-6 w-full text-sm text-red-800 bg-red-50 border border-l-4 border-red-300 border-l-red-600"
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};
